import m from "mithril"
import { MithrilTsxComponent } from "mithril-tsx-component"
import { loadScript, mounter } from "../utils"
import { getCulture, getTranslation } from "./chooseStore/translations"
import { ChooseStore } from "./chooseStore/index"
declare var process: any

interface IChooseStore {

}

class ChooseStorePage extends MithrilTsxComponent<IChooseStore> {
    view(v: m.Vnode<IChooseStore>) {
        return <section className="sm">
            <div className="container">
                <div className="checkout">
                    <div className="main">
                        <header>
                            <h1 className="title h1">{getTranslation("pageTitle")}</h1>
                            <p>{getTranslation("pageDescription")}</p>
                        </header>
                        <ChooseStore isExpressService />
                    </div>
                    <div className="side">
                        <div className="how-it-works">
                            <figure className="image">
                                <img width="720" height="458" loading="lazy" src="/FrontendWebpack/dist/assets/images/expressService/visual-balie.jpg" alt={getTranslation("hemaStoreCounter")} />
                            </figure>
                            <div className="body">
                                <span className="title h3">{getTranslation("howExpressServiceWorks")}</span>
                                <ul className="numbered-bullet-list">
                                    <li>{getTranslation("expressServiceBullet1")}</li>
                                    <li>{getTranslation("expressServiceBullet2")}</li>
                                    <li>{getTranslation("expressServiceBullet3")}</li>
                                    <li>{getTranslation("expressServiceBullet4")}</li>
                                    <li>{getTranslation("expressServiceBullet5")}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    }
}

mounter<IChooseStore>(`[data-m-choose-store]`, async (r, d) => {

    const culture = getCulture()
    const signature = { fr: "AQh_0C8PteoVUc7WshmnxnxSx0I=", nl: "8LYH9Qb0D4Mw0u9xQzczG4W-Ges=", }[culture.split("-")[0]]

    if (process.env.GOOGLE_TEST_URL)
        await loadScript(process.env.GOOGLE_TEST_URL)
    else
        await loadScript(`https://maps.googleapis.com/maps/api/js?key=AIzaSyBPdNXp6QWniB1YQpTNVqDb-yNukmQivvc&v=3.61&libraries=places&language=${culture}&signature=${signature}`)

    m.mount(r, {
        oncreate: dom => {
            const parent = dom.dom.parentElement
            const target = parent.parentElement
            target.append(...Array.from(parent.childNodes))
            parent.remove()
        },
        view: v => <ChooseStorePage />
    })
})